// splide-directive.js
import { Splide } from "@splidejs/splide";

export const vSplide = {
  mounted(el, binding) {
    // prevent double init
    if (el._splide) return;
    const opts = binding?.value || { mediaQuery: "min" };
    const instance = new Splide(el, opts);
    instance.mount();
    el._splide = instance;
  },
  updated(el, binding) {
    // If options change or slides change, you can refresh
    // el._splide?.refresh();
  },
  unmounted(el) {
    el._splide?.destroy(true);
    delete el._splide;
  },
};
